import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_CHECKLISTE_AUFGABEN = '[VeranstaltungenModul] GetChecklisteAufgaben laden';
export const GET_CHECKLISTE_AUFGABEN_AUSFUEHREN = '[VeranstaltungenModul] GetChecklisteAufgaben ausführen';
export const GET_CHECKLISTE_AUFGABEN_ERFOLGREICH = '[VeranstaltungenModul] GetChecklisteAufgaben laden erfolgreich';
export const GET_CHECKLISTE_AUFGABEN_FEHLER = '[VeranstaltungenModul] GetChecklisteAufgaben Ladefehler';
export const GET_CHECKLISTE_AUFGABEN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetChecklisteAufgaben nicht ausgeführt (evtl. Offline)';


export class GetChecklisteAufgabenAction implements Action {
    readonly type = GET_CHECKLISTE_AUFGABEN;
        constructor( public checkliste_id:string , public optPayload: any = null) {}
    }
export class GetChecklisteAufgabenAusfuehrenAction implements Action {
    readonly type = GET_CHECKLISTE_AUFGABEN_AUSFUEHREN;
        constructor( public checkliste_id:string , public optPayload: any = null) {}
    }
export class GetChecklisteAufgabenErfolgreichAction implements Action {
    readonly type = GET_CHECKLISTE_AUFGABEN_ERFOLGREICH;
        constructor(public payload: api.PhasenChecklistenAufgaben,  public checkliste_id:string , public optPayload: any = null) {}
    }
export class GetChecklisteAufgabenFehlerAction implements Action {
    readonly type = GET_CHECKLISTE_AUFGABEN_FEHLER;
        constructor(public payload: any,  public checkliste_id:string , public optPayload: any = null) {}
    }
export class GetChecklisteAufgabenNichtAusgefuehrtAction implements Action {
    readonly type = GET_CHECKLISTE_AUFGABEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryChecklisteAufgabenActions =
    GetChecklisteAufgabenAction
    | GetChecklisteAufgabenAusfuehrenAction
    | GetChecklisteAufgabenErfolgreichAction
    | GetChecklisteAufgabenFehlerAction
    | GetChecklisteAufgabenNichtAusgefuehrtAction
    ;
